import { useEffect } from "react";
import { useI18n } from "@/i18n/I18nContext";
import { useSite } from "@/context/SiteContext";
import { http, IS_CF } from "@/lib/api";

// Keeps the parent's preferred language in the D1 profile (Cloudflare backend only).
export const ProfileSync = () => {
  const { user, setUser } = useSite();
  const { lang } = useI18n();
  useEffect(() => {
    if (!IS_CF || !user || user.lang === lang) return;
    http.patch("/profile", { lang }).then(({ data }) => setUser(data)).catch(() => {});
  }, [user, lang, setUser]);
  return null;
};
